<div class="header-navigation-back">
  <mat-icon (click)="backAction()">arrow_back</mat-icon>
  <span class="title">Refer a friend</span>
</div>
<div class="margin-sides margin-bottom-lg">
  <div class="message-container padding-top-md" [innerHTML]="body"></div>
  <p class="padding-bottom-sm referral-link" data-test="referral-link">{{ referralLink }}</p>
</div>
<app-actions
  [actions]="actions"
  [ngClass]="showNavBar ? 'fixed-bottom' : 'native-app-fixed-bottom'"
  data-test="copy-link-button"
></app-actions>
